/* __next_internal_client_entry_do_not_use__ IconButtonStyles,IconWrapperStyles auto */ import { css } from "styled-components";
import { cssFromVariantTheme } from "../Button/styles";
import { StyledIconWrapper } from "./IconButton";
import { iconWrapperTheme } from "./theme";
var M_BUTTON_HEIGHT = 48;
var S_BUTTON_HEIGHT = 40;
var calculateButtonSize = function(size) {
    return "".concat(size === "small" || size === "S" ? S_BUTTON_HEIGHT : M_BUTTON_HEIGHT, "px");
};
var CIRCLE_BORDER_RADIUS = "50%";
var SQUARE_BORDER_RADIUS = "0";
var calculateBorderRadius = function(shape) {
    return "".concat(shape === "circle" ? CIRCLE_BORDER_RADIUS : SQUARE_BORDER_RADIUS);
};
export var IconButtonStyles = function(buttonProps) {
    var _buttonProps_$loading = buttonProps.$loading, $loading = _buttonProps_$loading === void 0 ? false : _buttonProps_$loading, _buttonProps_$shape = buttonProps.$shape, $shape = _buttonProps_$shape === void 0 ? "circle" : _buttonProps_$shape, _buttonProps_$variant = buttonProps.$variant, $variant = _buttonProps_$variant === void 0 ? "primary" : _buttonProps_$variant;
    var variantTheme = iconWrapperTheme[$variant];
    return css([
        "align-items:center;block-size:",
        "px;border-radius:",
        ";cursor:pointer;display:flex;inline-size:",
        "px;justify-content:center;&:disabled{cursor:not-allowed;}&:focus-visible{outline:5px auto -webkit-focus-ring-color;outline-offset:2px;",
        "{",
        "}}&:hover{",
        "{",
        "}}&:active{",
        "{",
        "}}&:disabled,&[disabled]{",
        "{",
        " cursor:not-allowed;}}"
    ], M_BUTTON_HEIGHT, calculateBorderRadius($shape), M_BUTTON_HEIGHT, StyledIconWrapper, cssFromVariantTheme(variantTheme, "focus", buttonProps), StyledIconWrapper, cssFromVariantTheme(variantTheme, "hover", buttonProps), StyledIconWrapper, cssFromVariantTheme(variantTheme, "active", buttonProps), StyledIconWrapper, $loading ? cssFromVariantTheme(variantTheme, "loading", buttonProps) : cssFromVariantTheme(variantTheme, "disabled", buttonProps));
};
export var IconWrapperStyles = function(buttonProps) {
    var _buttonProps_$shape = buttonProps.$shape, $shape = _buttonProps_$shape === void 0 ? "circle" : _buttonProps_$shape, _buttonProps_$size = buttonProps.$size, $size = _buttonProps_$size === void 0 ? "medium" : _buttonProps_$size, _buttonProps_$variant = buttonProps.$variant, $variant = _buttonProps_$variant === void 0 ? "primary" : _buttonProps_$variant;
    var variantTheme = iconWrapperTheme[$variant];
    return css([
        "align-items:center;block-size:",
        ";border-radius:",
        ";box-sizing:border-box;display:flex;fill:currentColor;inline-size:",
        ";justify-content:center;transition:background-color 0.2s ease,border 0.2s ease;",
        " svg{block-size:16px;color:inherit;inline-size:16px;}"
    ], calculateButtonSize($size), calculateBorderRadius($shape), calculateButtonSize($size), cssFromVariantTheme(variantTheme, "base", buttonProps));
};
